import 'regenerator-runtime/runtime';
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-markercluster/styles';
import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import * as ReactDOM from 'react-dom/client';
import React from 'react';
import '../../../../global.d.ts';
import FLoading from './FLoading';

const AppLoader = React.lazy(async () => import('./AppLoader'));

delete (L.Icon.Default.prototype as unknown as {_getIconUrl?: unknown})
  ._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
});

const root = ReactDOM.createRoot(document.getElementById('web'));

root.render(
  <React.Suspense fallback={<FLoading />}>
    <AppLoader />
  </React.Suspense>
);

// Drop the static boot splash once React has painted its first frame. The app's
// own FLoading (Suspense + serverInfo) continues the spinner on the same dark
// background, so the handoff is seamless.
requestAnimationFrame(() =>
  requestAnimationFrame(() => document.getElementById('boot-splash')?.remove())
);
